import Controller from '../components/Controller';
import Source from './Source';
import TileSource from './TileSource';

/**
 * 数据源控制管理类
 * 用于管理所有的数据源,解析数据源配置文件,请求服务数据等
 */
export default class SourceController extends Controller {
    /**
     * 根据App.Config.map.SourceConfig配置文件初始化所有类型的数据源.
     * @param {Object} config - sourceConfig配置
     * @returns {undefined}
     */
    loadConfig(config) {
        for (const [name, conf] of Object.entries(config)) {
            if (this.getSource(name)) {
                throw new Error(`数据源名称有重复: ${name}`);
            }

            let source;
            if (conf.type === 'tileSource') {
                source = new TileSource(name, conf);
            } else {
                source = new Source(name, conf);
            }

            this.add(source);
        }
    }

    /**
     * 根据数据源名称获取数据源.
     * @param {String} sourceName - 数据源名称
     * @returns {Object} - 返回已sourceName为键值的数据源
     */
    getSource(sourceName) {
        for (const s of this.elements) {
            if (s.name === sourceName) {
                return s;
            }
        }

        return null;
    }
}
